/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyDto } from './loyaltyDto';
import { PersonalizationDto } from './personalizationDto';
import { PlaceInformationDto } from './placeInformationDto';
import { LocationDto } from './locationDto';


export interface ClientCompanyDto { 
    id?: number;
    uuid?: string;
    companyName?: string;
    companyNo?: string;
    logo?: string;
    phone1?: string;
    phone2?: string;
    email?: string;
    hqLocation?: LocationDto;
    loyalty?: LoyaltyDto;
    loyaltyName?: string;
    showCompanyOffices?: boolean;
    personalization?: PersonalizationDto;
    placeInformation?: PlaceInformationDto;
    pointsToNextCoupon?: number;
    currency?: string;
    priceToPointsRatio?: number;
}

